export default __webpack_public_path__ + "static/media/top-view-photography-accesories-with-copy-space_23-2148363427.795f8fe3.jpg";